import React from "react";
import Box from '@mui/material/Box';
import './home.css';


const HomeBox = () => {

    // const myStyle = {
    //     backgroundImage: 'url("./images/vert_img_1.jpg")',
    //     height: '100%',
    //     marginLeft: '86%',
    //     position: 'inherit',
    //     width: '6.2%',
    //     backgroundPosition: 'left center',
    //     backgroundSize: '97%',
    //     backgroundRepeat: 'no-repeat',
    // };
    return (

        <>
            <Box sx={{ backgroundColor: '#202020', width: '100vw', maxWidth: '100%', minWidth: '100%', height: '100vh', maxheight: '100%' }}>
                <div className="homebox__container">
                    <p className="homebox__head">
                        Untouched
                    </p>

                    <div className="homebox__rect">
                        <div className="homebox__rect__r-l"></div>

                        <div className="homebox__rect__r-u"></div>
                    </div>



                    <div className="homebox__vert__theo">
                        <pre className="homebox__note">{`Say Hello to Handsfree Hygiene,
With Untouched
    `}</pre>
                        <div className='faint__note'>The smart sanitizer dispenser</div>
                        <div className="pre_order">
                            <a href="https://pages.razorpay.com/untouchedHST" rel="noreferrer" target='_blank'><button className="bt__pre">PRE-ORDER</button></a>
                        </div>
                    </div>


                    <div className="homebox__img">
                        <img id='homebox__img' src="/images/home_img/senitizer.191.png" alt="" />

                    </div>

                    <div className="back__vert" ></div>

                    <div className='homebox__social'>
                        <a target='_blank' rel="noreferrer" href="https://www.linkedin.com/company/gountouched/"><img id="s-icon" src="/images/social-icon/Linkedin Black.svg" alt="" /></a>
                        <a target='_blank' rel="noreferrer" href="https://twitter.com/gountouched"><img id="s-icon" src="/images/social-icon/Twitter Black.svg" alt="" /></a>
                        <a target='_blank' rel="noreferrer" href="https://www.instagram.com/go_untouched/"> <img style={{ backgroundColor: 'white', borderRadius: '15px' }} id="s-icon" src="/images/social-icon/Instagram Black.svg" alt="" /></a>
                    </div>
                </div>
            </Box>
        </>

    );
}

export default HomeBox;